// Texts for the footer
const footer = {
    legalNotices: 'Aviso legal',
    termesOfUse: 'Condiciones de uso',
    privacyPolicy: 'Política de privacidad',

    instagramIconTitle: 'Instagram',
    whatsappIconTitle: "What's App",

    logoAlt: 'Logo',
};

export default footer;
